import { gql } from '@apollo/client/core';
import { imageBlockFragment } from './image-block.fragment';
import { textBlockFragment } from './text-block.fragment';
import { buttonBlockFragment } from './button-block.fragment';

export const bannerBlockFragment = gql`
  fragment BannerBlockFields on BannerBlock {
    entryTitle
    bannerImage {
      ...ImageBlockFields
    }
    title {
      ...TextBlockFields
    }
    subtitle {
      ...TextBlockFields
    }
    actionButton {
      ...ButtonBlockFields
    }
  }
  ${imageBlockFragment}
  ${textBlockFragment}
  ${buttonBlockFragment}
`;
